// extracted by mini-css-extract-plugin
export default {"Code":"Code1GcUiWRi7v92","MdxExpression":"MdxExpression11FWETB-vBUg","MdxJsxTextElement":"MdxJsxTextElement3gg5LNXh7o_v","GlossaryTermLeaf":"GlossaryTermLeaf3gUwtS6Ty03a"};